<template>
  <div>
    <div v-if="showMessage" class="pull-to-refresh">
      <span>{{ $t('pullToRefresh.message') }}</span>
    </div>
    <div v-if="!showMessage" class="indicator"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PullToRefresh',
  props: {

  },
  data: ()  => {
    return {
      touchStartY: 0,
      triggerLength: 80,
      triggerStart: 0,
      showMessage: false,
    }
  },
  mounted() {
    document.addEventListener('touchstart', e => {
      this.touchStartY = e.touches[0].clientY;
    });

    document.addEventListener('touchmove', e => {
      const touchY = e.touches[0].clientY;
      const touchDiff = touchY - this.touchStartY;

      if (touchDiff > 0 && window.scrollY === 0) {
        if (this.triggerStart === 0) {
          this.triggerStart = touchDiff;
        } else {
          const diff = touchDiff - this.triggerStart;
          const indicator = document.querySelector('.indicator');
          const progressPercentage = 100 * diff / this.triggerLength;

          if (diff >= this.triggerLength) {
            if (indicator) {
              indicator.style['width'] = '100%';
            }

            this.showMessage = true;
          }

          if (!this.showMessage) {
            indicator.style['width'] = `${progressPercentage}%`;
          }

        }
      }
    }, {passive: false});

    document.addEventListener('touchend', () => {
      this.touchStartY = 0;
      this.triggerStart = 0;
      const indicator = document.querySelector('.indicator');

      if (indicator) {
        indicator.style['width'] = '0%';
      }
      if (this.showMessage) {
        this.showMessage = false;
        location.reload();
      }
    });
  }
}
</script>

<style >
body {
  overscroll-behavior-y: none;
}
.pull-to-refresh {
  position: fixed;
  border-radius: 2rem;
  margin-top: 10px;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: top 0.7s ease-in-out;
  z-index: 31;
  background-color: #3395ff;
  color: white;
  font-weight: bold;
}

.indicator {
  position: fixed;
  width: 0%;
  left: 0;
  top: 0;
  border-radius: 2rem;
  background-color: #3395ff;
  height: 5px;
  z-index: 31;
}
</style>